import { css } from 'styled-components';

import colors from '../settings/colors';
import variables from '../settings/variables';

export default css`
  * {
    box-sizing: border-box;

    &:before,
    &:after {
      box-sizing: border-box;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }

  html {
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-size: ${variables.fontSizeBase};
    overflow-x: hidden;
  }

  body {
    background-color: ${colors.bodyBg};
    background-size: 100%;
    color: ${colors.colorTextBody};
    font-family: ${variables.fontFamilyBase};
    font-weight: ${variables.fontWeightBase};
    margin: 0;
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;

    &.no-scroll {
      overflow: hidden;
    }
  }

  #root {
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
  }

  input,
  button,
  select,
  textarea {
    background: transparent;
    border: none;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  button {
    cursor: pointer;
    font-size: inherit;
    margin: 0;
    padding: 0;
    text-align: inherit;
    text-transform: inherit;
    transition: 0.3s;
  }

  a {
    color: inherit;
    text-decoration: none;
    transition: 0.3s;

    &:hover,
    &:focus {
      text-decoration: none;
    }
  }

  img {
    max-height: 100%;
    max-width: 100%;
  }

  &::placeholder {
    color: ${colors.frenchGray};
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  .ReactModal__Body--open {
    overflow-y: hidden;
  }
`;
